import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Heading from "../Heading";
import API from "../../../utils/API";
import { redirectFromCheckout } from "../../../utils/functions";

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  max-width: ${(props) => props.theme.sizes.maxWidth};
  margin: 0 auto;
  margin-top: 0;
  padding-top: 22px;
  padding-right: 24px;
  padding-left: 24px;

  h3 {
    font-size: 2em;
  }

  p {
    font-size: 20px;
    line-height: 1.6;
    letter-spacing: normal;
  }

  a {
    color: var(--color-primary);
    border-bottom: 1px solid var(--color-primary);

    &:hover {
      border-bottom: 1px solid var(--color-base-text);
    }
  }

  .spacer {
    margin: 0 15px;
  }

  .btn-orange {
    margin-top: 20px;
    appearance: none;
    background: var(--color-primary);
    color: #fff;
    font-size: 15px;
    padding: 12px 50px;
    border-radius: 25px;
    display: inline-block;
    border: 1px solid var(--color-primary);
    transition: All 0.5s;
    min-width: 120px;
    text-align: center;

    &:hover {
      color: var(--color-primary);
      background-color: #fff;
    }
  }

  .meal-app__bt-fx {
    @media (max-width: 768px) {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }

  @media (min-width: 990px) {
    padding-top: 90px;
  }
`;

const MainHeading = styled(Heading)`
  padding-top: 0;
  padding-bottom: 8px;
  border-bottom: 1px solid #e6e6e6;
  font-size: 36px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.22;
  letter-spacing: -1.95px;

  @media (min-width: 990px) {
    margin-bottom: 24px;
    border-bottom: none;
    font-size: 48px;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.17;
    letter-spacing: -2.6px;
  }
`;

function NoDataReceived() {
  const [cartItemsFound, setCartItemsFound] = useState(null);

  useEffect(() => {
    async function fetchCartData() {
      let url="https://modifyhealth.com/cart.js";
      if (process.env.REACT_APP_MODE === 'production' || process.env.REACT_APP_MODE === 'production-build'){
        url="https://modifyhealth.com/cart.js";
      } else if (process.env.REACT_APP_MODE === "test" || process.env.REACT_APP_MODE === "test-build") {
        url="https://test-modifyhealth.myshopify.com/cart.js";
      } else {
        url="https://devmodifyhealth.myshopify.com/cart.js";
      }
      const data = await API.get(url);
      return data;
    }

    fetchCartData()
      .then((data) => {
        const count = data.data.item_count;

        if (!count) {
          setCartItemsFound(false);
          return;
        }

        setCartItemsFound(true);
      })
      .catch((err) => {
        setCartItemsFound(false);
      });
  }, []);

  redirectFromCheckout();

  return (
    <Wrap id="meal-app__no-ch" className="meal-app__no-ch">
      <MainHeading>Upcoming Deliveries</MainHeading>
      <p>No upcoming deliveries found.</p>
      {cartItemsFound && (
        <>
          <p>
            <b>Your shopping cart is waiting for you.</b>
            <br />
            There are some meals in the shopping cart. Would you like to complete your purchase?
          </p>
          <p className="meal-app__bt-fx">
            <a href="/cart" className="btn-orange">
              <b>PROCEED TO CART</b>
            </a>
            <span className="spacer">or</span>
            <a href="/collections/diets" className="link">
              <b>continue shopping</b>
            </a>
          </p>
        </>
      )}
      {cartItemsFound !== null && !cartItemsFound && (
        <p className="meal-app__bt-fx">
          <a href="/collections/diets" className="btn-orange">
            <b>CONTINUE SHOPPING</b>
          </a>
        </p>
      )}
    </Wrap>
  );
}

export default NoDataReceived;
